import { ApiService } from 'services';

import { handleException } from 'actions/exceptions';
import { getSiteConfig } from 'actions';
import { AUTH_STATE_UNAUTHORISED } from 'actions/auth';

export const SITE_PRELOAD_REQUEST = 'SITE_PRELOAD_REQUEST';
export const SITE_PRELOAD_SUCCESS = 'SITE_PRELOAD_SUCCESS';

function request() {
  return {
    type: SITE_PRELOAD_REQUEST
  };
}

function receive() {
  return {
    type: SITE_PRELOAD_SUCCESS,
  };
}

function failed() {
  return {
    type: AUTH_STATE_UNAUTHORISED
  };
}

export function getSitePreload(json) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService.getDspConsole(json.url, json.headers)
      .then((response) => {
        if (json.success.includes(response.status)) {
          dispatch(receive());
          dispatch(getSiteConfig());
        } else {
          dispatch(handleException(response, failed, false));
        }
      }).catch((error) => {
        dispatch(handleException(error, failed, false));
      });
    return promise();
  };
}
